import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

import { globalCss } from './global-css';
import { semanticTokens } from './semantic-tokens';
import { tokens } from './tokens';

/**
 * Chakra UI system config → pass to `createSystem`, then `ChakraProvider value={system}`.
 * @see https://chakra-ui.com/docs/theming/overview
 */
export const themeConfig = defineConfig({
  globalCss,
  theme: {
    tokens,
    semanticTokens,
  },
});

export const system = createSystem(defaultConfig, themeConfig);
